<template lang="">
  <v-card class="hc__rounded-card">
    <div class="imagen-a">
      <v-img
        class="img"
        src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/helpcenter_img_02.png"
      ></v-img>
    </div>
    <v-card-title class="text-xs-center">
      <v-flex class="title ma-0 font-weight-thin hc__blue-text">
        ¿Necesitas ver tu historial de casos?
      </v-flex>
    </v-card-title>
    <v-card-actions class="text-xs-center">
      <v-flex>
        <v-btn outline class="hc__color-2" :to="'/centro-de-ayuda/mis-casos'">
          Ir a Mis casos
        </v-btn>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  
}
</script>
<style lang="css">
.hc__rounded-card{
  border-radius: 0.5rem
}


.hc__color-2 {
  color:#28385C !important
}
.imagen-a{
  height: 120px;
  margin:auto;
}
.img{
  top: -35px;
  margin:auto;
  height: 200px;
  width: 200px;
  }
</style>